/* eslint-disable import/prefer-default-export */
import env from 'scramble/env';
import md5hash from 'crypto-js/md5';

export const tenantId = () => env.getFlag('tenantId') || md5hash(window.shortClientKey).toString();
